export default __webpack_public_path__ + "static/media/male_shoulder.3c4bf545.png";